import { render, staticRenderFns } from "./ktpMessage.vue?vue&type=template&id=01439cc9&scoped=true"
import script from "./ktpMessage.vue?vue&type=script&lang=ts"
export * from "./ktpMessage.vue?vue&type=script&lang=ts"
import style0 from "./ktpMessage.vue?vue&type=style&index=0&id=01439cc9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01439cc9",
  null
  
)

export default component.exports